import labels from '../../utils/constants/labels';
import ApiValues from '../url/apiurl'
var axios = require('axios');
import Networking from '../../utils/api/apiaccess';
import { Asset } from '../../utils/mainasset';
function VerifyOTPLoginWithEmail(email, otp) {

  let data = {};
  data.EmailOTP = otp;
  data.EmailID = email
  data.Source = Asset.source

  // var config = {
  //   method: 'post',
  //   url: ApiValues.SendOtpPassword,
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   data: data
  // };

  // return axios(config)
  //   .then(function (response) {
  //     return response.data;
  //   })
  //   .catch(function (error) {
  //     return {"status":"F","message":labels.messages.apierror}
  //   });

  return Networking.PostApi(ApiValues.VerifyOTPLoginWithEmail, data, labels.apiKey.apiKeys, labels.apiKey.apiKeys, true).then(result => { return result })
    .catch(function (error) {
      return { "status": "F", "message": labels.messages.apierror }
    });
}
export default VerifyOTPLoginWithEmail